import { Injectable, Signal, inject } from '@angular/core';
import { AuthState } from '../../states/auth.state';

/**
 * Get Access Token use case.
 * Retrieves the current access token from state.
 */
@Injectable({ providedIn: 'root' })
export class GetAccessTokenUseCase {
  private readonly authState = inject(AuthState);

  /**
   * Executes the get access token use case.
   * @returns Observable with the current access token or null
   */
  execute(): Signal<string | null> {
    return this.authState.accessToken;
  }
}
